import '../../css/Login.css';
import { Button, Form, Input, Modal } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import axiosClient from '../../utils/axiosClient';
import checkInputFormat from '../../utils/misc/validation';
import rejected from '../../images/Haleon/rejected.png';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const LoginForm = () => {
	const searchParams = new URLSearchParams(window.location.search);
	const { t } = useTranslation();
	const location = useLocation();
	const navigate = useNavigate();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const [disabled, setDisabled] = useState(false);
	const [success, setSuccess] = useState(false);
	const [exist, setExist] = useState(false);
	// const [number, setNumber] = useState('');
	const [errorModal, setErrorModal] = useState(false);
	const storeId = location.state?.storeId;
	const referId = location.state?.referId;
	const isSGRegion =
		window.location.hostname.replace('www.', '') ===
		process.env.REACT_APP_SG_DOMAIN;
	const regexPhoneNum = isSGRegion ? /^([0-9]{8})$/ : /^(1[0-9]{8,9})$/;

	const validator = async (rule, value) => {
		const { result, message } = checkInputFormat({ [rule.field]: value });
		if (!result) {
			setDisabled(true);
			return Promise.reject(new Error(message));
		} else {
			setDisabled(false);
		}
	};

	const handleSubmit = async (values) => {
		setLoading(true);

		try {
			const sendData = {
				phone: (isSGRegion ? '65' : '60') + values.phone,
				type: 'WEBHOOK'
			};
			const res = await axiosClient.post('/auth/check-user', sendData);

			setLoading(false);

			if (res && res.data?.identity) {
				if (res.data?.identity !== 'REGISTER') {
					// remove all the local storage
					localStorage.removeItem('HALEON-REWARDS_REFER_CODE');
					localStorage.removeItem('HALEON-REWARDS_PROMOTER_CODE');
					localStorage.removeItem('HALEON-REWARDS_PROMOTER_ID');
					localStorage.removeItem('HALEON-REWARDS_CHANNEL');
					localStorage.removeItem('HALEON-REWARDS_STORE_CODE');
					localStorage.removeItem('HALEON-REWARDS_STORE_ID');
				}
				const data = {
					...values,
					identity: res.data?.identity,
					// storeId,
				};
				// console.info("res", res);
				navigate(`/verify-otp${window.location.search}`, { state: data });
			}
		} catch (error) {
			console.log('error', error);
			setErrorModal(true);
			setLoading(false);
			setExist(true);
			setError(error.response.data.error);
		}
	};

	return (
		<div>
			<div>
				<Form
					form={form}
					name="login-form"
					id="login-form"
					onFinish={handleSubmit}
					disabled={loading}
					aria-label="form"
					data-testid="login-form"
					autoComplete="off"
					style={{ textAlign: 'center', marginTop: '10%', color: 'white' }}
				>
					<div
						style={{
							display: 'flex',
							justifyContent: 'left',
							background: 'transparent',
						}}
					>
						<div
							style={{
								borderRadius: '10px',
								border: '2px solid #DEDEDE',
								background: 'transparent',
								width: '16%',
								height: '40px',
								fontSize: '12px',
								color: 'white',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								marginLeft: '10%',
							}}
						>
							<span>+{isSGRegion ? '65' : '60'}</span>
						</div>

						<Form.Item
							name="phone"
							validateDebounce={500}
							hasFeedback
							className="login-text-color"
							style={{ fontSize: '12px', width: '110%', textAlign: 'left' }}
							rules={[
								{
									required: true,
									message: 'Phone is required',
								},
								({ getFieldValue }) => ({
									validator(_, value) {
										if (value && value?.length > 0) {
											if (regexPhoneNum.test(value)) {
												return Promise.resolve(true);
											}
											return Promise.reject(
												new Error('Invalid phone number format!')
											);
										}
										return Promise.resolve(true);
									},
								}),
							]}
						>
							<Input
								type="tel"
								name="phone"
								style={{
									borderRadius: '10px',
									border: '2px solid #DEDEDE',
									background: 'transparent',
									width: '80%',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									margin: 'auto',
									height: '40px',
									position: 'relative',
									right: '3%',
									color: 'white',
								}}
								className="input-placeholder"
								placeholder="Your phone number"
							/>
						</Form.Item>
					</div>
					<Form.Item>
						<Button
							type="primary"
							htmlType="submit"
							className="font-family-hero-new" 
							style={{
								width: '80%',
								backgroundColor: '#30E700',
								color: 'black',
								border: 'none',
								height: '40px',
								fontSize: '16px',
								fontWeight: '500px'
							}}
							>
								<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
									<p>{t('Send OTP Code')}</p>
									<svg  width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M7.1185 24.5814L7.60687 24.8289C9.64203 26.0663 11.9212 26.6438 14.2005 26.6438C21.3638 26.6438 27.2247 20.704 27.2247 13.4442C27.2247 9.97938 25.8408 6.59696 23.3988 4.12199C20.9568 1.64703 17.7006 0.244629 14.2005 0.244629C7.03716 0.244629 1.17616 6.18444 1.25761 13.5268C1.25761 16.0016 1.99022 18.3942 3.2112 20.4565L3.53678 20.9515L2.23447 25.8189L7.1185 24.5814Z" fill="#00E676"/>
										<path d="M23.4048 3.9242C20.9545 1.38078 17.5673 0 14.108 0C6.75725 0 0.847687 6.03163 0.919697 13.3713C0.919697 15.6968 1.5683 17.9497 2.64938 19.9844L0.775574 26.8881L7.76611 25.0713C9.71193 26.1614 11.8739 26.6701 14.036 26.6701C21.3148 26.6701 27.2244 20.6384 27.2244 13.2988C27.2244 9.73788 25.8551 6.395 23.4049 3.9242H23.4048ZM14.108 24.4174C12.1622 24.4174 10.2164 23.9088 8.55884 22.8914L8.12647 22.6733L3.94659 23.7633L5.02757 19.6212L4.73932 19.1851C1.5683 14.0256 3.08175 7.19436 8.27059 3.99681C13.4594 0.799362 20.1617 2.32547 23.3327 7.55774C26.5037 12.79 24.9902 19.5484 19.8015 22.7459C18.1438 23.836 16.126 24.4173 14.108 24.4173V24.4174ZM20.45 16.351L19.6572 15.9877C19.6572 15.9877 18.5043 15.479 17.7835 15.1156C17.7114 15.1156 17.6394 15.0429 17.5673 15.0429C17.3511 15.0429 17.2069 15.1156 17.0628 15.1883C17.0628 15.1883 16.9908 15.2609 15.9818 16.4236C15.9097 16.569 15.7656 16.6417 15.6215 16.6417H15.5494C15.4774 16.6417 15.3332 16.569 15.2611 16.4964L14.9008 16.351C14.108 15.9877 13.3874 15.5516 12.8108 14.9703C12.6667 14.8249 12.4505 14.6796 12.3063 14.5343C11.8019 14.0256 11.2974 13.4441 10.9371 12.7901L10.865 12.6448C10.793 12.5721 10.793 12.4994 10.7209 12.3541C10.7209 12.2088 10.7209 12.0635 10.793 11.9907C10.793 11.9907 11.0813 11.6274 11.2974 11.4094C11.4416 11.264 11.5136 11.0461 11.6577 10.9007C11.8019 10.6827 11.874 10.392 11.8019 10.174C11.7299 9.8106 10.865 7.8485 10.6489 7.41251C10.5047 7.19447 10.3606 7.12186 10.1444 7.04914H9.35167C9.20744 7.04914 9.06342 7.12186 8.9192 7.12186L8.84708 7.19447C8.70296 7.26718 8.55884 7.41251 8.41472 7.48513C8.27059 7.63056 8.19848 7.77578 8.05436 7.92122C7.54987 8.57525 7.26163 9.37461 7.26163 10.174C7.26163 10.7553 7.40575 11.3367 7.62199 11.8454L7.6941 12.0635C8.34271 13.4441 9.20744 14.6796 10.3606 15.7696L10.6489 16.0603C10.865 16.2783 11.0813 16.4236 11.2254 16.6416C12.7388 17.9498 14.4684 18.8944 16.4142 19.4032C16.6305 19.4758 16.9187 19.4758 17.1349 19.5485H17.8556C18.2159 19.5485 18.6483 19.4032 18.9366 19.2578C19.1528 19.1125 19.2969 19.1125 19.441 18.9672L19.5852 18.8217C19.7294 18.6764 19.8735 18.6038 20.0176 18.4585C20.1617 18.3131 20.3058 18.1678 20.378 18.0224C20.5221 17.7317 20.5941 17.3683 20.6662 17.0051V16.4964C20.6662 16.4964 20.5941 16.4236 20.45 16.351Z" fill="white"/>
									</svg>
								</div>
						</Button>
					</Form.Item>
				</Form>
			</div>

			<div>
				<Modal
					open={success}
					centered
					header={null}
					footer={null}
					closable={true}
				>
					<div className="submit-login-success-modal-container">
						<img
							alt=""
							className="submit-success-icon"
							style={{ width: '15vw' }}
						></img>
						<div className="submit-login-modal-header">Success!</div>
						<div className="submit-login-success-modal-font">
							New one-time PIN sent. Please check your phone for the code.
						</div>
						<Button onClick={() => navigate('/verify-otp')}>DONE</Button>
					</div>
				</Modal>
			</div>

			<div>
				<Modal
					open={errorModal}
					centered
					footer={null}
					width={300}
					closable={true}
					onCancel={() => setErrorModal(false)}
				>
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<img src={rejected} alt="" style={{ width: '20%' }}></img>
					</div>
					<br />
					<div
						style={{
							fontWeight: 'bold',
							fontSize: '20px',
							textAlign: 'center',
						}}
					>
						Unable to send OTP
						<p className="text-center">please try again</p>
					</div>
				</Modal>
			</div>
		</div>
	);
};

export default LoginForm;
